<template>
  <el-dialog
    :visible.sync="visible"
    append-to-body
    :show-close="true"
    :center="true"
    :before-close="handleClose"
    title="手机号邀请"
    width="500px"
  >
    <div>
      <el-form ref="form" :model="formData"  :rules="rules" label-width="100px">
       
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formData.name"  placeholder="请输入"></el-input>
        </el-form-item>


        <el-form-item label="性别" prop="sex" >
          <el-radio-group v-model="formData.sex">
            <el-radio :label="1">男</el-radio>
            <el-radio :label="2">女</el-radio>
            <el-radio :label="0">不公开</el-radio>
          </el-radio-group>
        </el-form-item>


        <el-form-item label="手机号	" prop="mobile" >
          <el-input  type="number" v-model="formData.mobile" ></el-input>
        </el-form-item>



        <el-form-item label="面试时间" prop="audit_at" >  
          <el-date-picker
            v-model="formData.audit_at"
            type="datetime"
            placeholder="选择面试时间">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="面试地点" prop="address">
          <el-input v-model="formData.address" @focus="selectPoint" placeholder="选择面试地点"></el-input>
        </el-form-item>


        <el-form-item label="联系人	" prop="person_name" >
          <el-input  type="text" v-model="formData.person_name" ></el-input>
        </el-form-item>


        <el-form-item label="联系方式	" prop="person_phone" >
          <el-input  type="number" v-model="formData.person_phone" ></el-input>
        </el-form-item>


      
       
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="submit">确 定</el-button>
      <el-button @click="handleClose">取 消</el-button>
    </span>

    <select-point-dialog ref="mapDialog"  @setAddress="setAddress"></select-point-dialog>

  </el-dialog>
</template>

<script>
import { importAudit,importMobile} from "@/api/director/interview/index";
import selectPointDialog from "@/components/map/select-point-dialog.vue";

export default {
  components: { selectPointDialog},

  data() {
    return {
      visible: false,

      formData: {
        project_id:'',
        job_id:'',
        mobile:"",
        sex:"",
        name:"",
        address: "",
        audit_at: "",
        person_name: "",
        person_phone: "",
        address_type:"2",
        lat:"",
        lng:"",
      
        mark:''
       
      },
       rules: {
          mobile: [
              {required: true, message: '请填写用户手机号', trigger: 'blur'}
          ],
          sex: [
              {required: true, message: '请选择性别', trigger: 'blur'}
          ],
          name: [
              {required: true, message: '请填写用户名', trigger: 'blur'}
          ],

          audit_at: [
              {required: true, message: '请选择面试时间', trigger: 'blur'}
          ],
          address: [
              {required: true, message: '请输入面试地点', trigger: 'change'}
          ],
          person_phone: [
              {required: true, message: '请输入联系方式', trigger: 'blur'}
          ],

          person_name: [
              {required: true, message: '请输入联系人', trigger: 'blur'}
          ]

          

       }
    };
  },

 
  mounted() {

},
destroyed(){
  this.handleClose();
},
  
  methods: {
    handleClose() {
      this.visible = false;
      this.$refs["form"].resetFields();

    },


    init(project_id,job_id) {
      this.visible = true;
      this.formData.project_id=project_id;
      this.formData.job_id=job_id;

    },

    selectPoint(){
      this.$refs.mapDialog.init();
    },

    setAddress(data){
      console.log(data)
      this.formData.lat=data.lat;
      this.formData.lng=data.lng;
      this.formData.address=data.address;
      
    },
    
    
    submit(){
      var that=this;
      if(this.formData.lat === '' || this.formData.lng === ''){
            this.$message.error('请先选择地址！');
            return;
        }

      this.$refs["form"].validate((valid) => {
          if (valid) {
            importMobile(that.formData).then((response) => {
              console.log(response);
              if(response.code==200){
                this.$message({
                   message: "提交成功",
                   type: 'success'
                });
               // that.$emit('refresh');
                that.visible = false;
              
              }else{
                this.$message({
                  message: response.msg?response.msg:"提交失败",
                });
              }
            });
          } 
        });
    },

  },

 
};
</script>

<style lang="scss" scoped>
::v-deep .myWindow {
    border-radius: 15px;



.el-button--primary {
  color: #FFF;
  background-color: #717ebb;
  border-color: #717ebb;
}


/*
.footer{
  display: flex;
  justify-content: center;
}*/


  }
</style>
